<template>
  <div class="user-manager">
    <el-button type="three" size="medium" @click="add">新增</el-button>
    <el-table
      :data="userLists"
      style="width: 100%"
      :header-cell-style="{ background: '#F0F3F7', color: '#39475B' }"
      :cell-style="{
        background: '#FCFDFF',
        'font-size': '14px',
        color: '#8998AC',
      }"
    >
      <el-table-column prop="id" label="工号" align="center"></el-table-column>
      <el-table-column
        prop="user_name"
        label="登录账号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="nickname"
        label="昵称"
        align="center"
      ></el-table-column>
      <el-table-column prop="role_id" label="角色名称" align="center"
        ><template slot-scope="scope">{{
          getRolename(scope.row)
        }}</template></el-table-column
      >
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <my-operation :scope="scope" @add="add" @deleteItem="deleteItem">
            <el-tooltip
              class="item"
              effect="dark"
              content="重置密码"
              placement="bottom"
            >
              <el-button
                @click="resetPassword(scope.row)"
                type="two"
                icon="iconfont icon-zhongzhimimaicon-"
                circle
                size="medium"
              ></el-button>
            </el-tooltip>
          </my-operation>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="10"
      layout="total, prev, pager, next, jumper"
      :total="total"
      prev-text="上一页"
      next-text="下一页"
      v-if="total > 10"
    >
    </el-pagination>
    <el-dialog
      :close-on-click-modal="false"
      title="新增"
      :visible.sync="isOpened"
      width="800px"
      :before-close="closeAdd"
    >
      <el-form
        :model="userForm"
        label-width="110px"
        class="demo-ruleForm"
        label-position="left"
        :rules="rules2"
        ref="addForm"
      >
        <el-form-item label="头像选择：" prop="logo_url">
          <upload-img :img.sync="userForm.logo_url"></upload-img>
        </el-form-item>
        <el-form-item label="用户昵称：" prop="nickname">
          <el-input
            v-model="userForm.nickname"
            placeholder="请输入用户昵称"
          ></el-input>
        </el-form-item>
        <el-form-item label="登录账号：" prop="user_name">
          <el-input
            v-model="userForm.user_name"
            placeholder="请输入登录账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="初始密码：" prop="password">
          <el-input
            v-model="userForm.password"
            type="password"
            placeholder="请输入初始密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择角色：" prop="role_id">
          <el-select v-model="userForm.role_id" placeholder="请选择角色">
            <el-option
              v-for="item in roleLists1"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职位：" prop="position">
          <el-input
            v-model="userForm.position"
            placeholder="请输入职位"
          ></el-input>
        </el-form-item>
        <el-form-item label="个人介绍：" prop="desc">
          <el-input
            v-model="userForm.desc"
            type="textarea"
            placeholder="请输入个人介绍"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" round @click="closeAdd">取消</el-button>
        <el-button size="medium" round type="primary" @click="vertifyConfirm"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="重置密码"
      :visible.sync="resetVisible"
      width="800px"
      :before-close="closeReset"
    >
      <el-form
        :model="currentItem"
        label-width="100px"
        class="demo-ruleForm"
        label-position="left"
        :rules="rules1"
        ref="resetForm"
      >
        <el-form-item label="新密码：" prop="password">
          <el-input
            v-model="currentItem.password"
            type="password"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" round @click="closeReset">取消</el-button>
        <el-button size="medium" round type="primary" @click="changePassword"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { isSuccess, getCompletionUrl } from '@/utils/index'
  import { USER_DEFAULT_AVATAR } from '@/utils/const'
  import {
    getUserList,
    getRoleList,
    getUserDetail,
    addUser,
    deleteUser,
    resetPassword,
  } from '@/api/account'
  export default {
    components: {
      'my-operation': () => import('@/components/operation/index.vue'),
      'upload-img': () => import('@/components/uploadImg/index.vue'),
    },
    data() {
      return {
        userLists: [],
        roleLists: [],
        roleLists1: [],
        isOpened: false,
        currentPage: 1,
        total: 0,
        userForm: {
          user_name: '',
          nickname: '',
          logo_url: USER_DEFAULT_AVATAR,
          role_id: '',
          desc: '',
          position: '',
          password: '',
        },
        deleteVisible: false,
        resetVisible: false,
        currentItem: {},
        operation: 'add',
        password: '',
        rules1: {
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, message: '长度在至少为6位数', trigger: 'blur' },
          ],
        },
        rules2: {
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, message: '长度在至少为6位数', trigger: 'blur' },
          ],
          user_name: [
            { required: true, message: '请输入登录账号', trigger: 'blur' },
          ],
          nickname: [
            { required: true, message: '请输入用户昵称', trigger: 'blur' },
          ],
          role_id: [{ required: true, message: '请选择角色', trigger: 'blur' }],
          position: [
            { required: true, message: '请输入职位', trigger: 'blur' },
          ],
          logo_url: [
            { required: true, message: '请上传头像', trigger: 'blur' },
          ],
        },
      }
    },
    mounted() {
      this.getLists()
      this.getRoleLists()
    },
    computed: {
      getRolename() {
        return (row) => {
          let item = this.roleLists.find((val) => val.id == row.role_id)
          return item ? item.name : ''
        }
      },
    },
    methods: {
      async getLists() {
        const res = await getUserList({
          page: this.currentPage,
        })
        this.userLists = res.data.list
        this.total = res.data.total
      },
      async getRoleLists() {
        const res = await getRoleList({ page: 1, pagesize: 100 })
        this.roleLists = res.data.list
        this.roleLists1 = JSON.parse(JSON.stringify(res.data.list))
      },
      handleCurrentChange() {
        this.getLists()
      },
      async add(row) {
        if (row.id) {
          this.operation = 'edit'
          const res = await getUserDetail({
            id: row.id,
          })
          this.userForm = { ...res.data, password: '' }
        }
        this.isOpened = true
      },

      closeAdd() {
        this.$refs.addForm.resetFields()
        this.userForm = {
          user_name: '',
          nickname: '',
          logo_url: USER_DEFAULT_AVATAR,
          role_id: '',
          desc: '',
          position: '',
          password: '',
        }
        this.password = ''
        this.isOpened = false
        this.operation = 'add'
      },
      closeReset() {
        this.$refs.resetForm.resetFields()
        this.resetVisible = false
      },
      vertifyConfirm() {
        this.$refs.addForm.validate((valid) => {
          if (!valid) {
            this.$message.error('信息不完整')
            return
          }
          this.confirm()
        })
      },
      async confirm() {
        let form = {
          user_name: this.userForm.user_name,
          nickname: this.userForm.nickname,
          logo_url: this.userForm.logo_url,
          role_id: this.userForm.role_id,
          desc: this.userForm.desc,
          position: this.userForm.position,
          password: this.userForm.password,
        }
        if (this.operation == 'edit') {
          form.id = this.userForm.id
        }
        const res = await addUser(form, this.operation)
        if (isSuccess(res.code)) {
          this.$message.success(
            `${this.operation == 'add' ? '添加成功' : '编辑成功'}`
          )
          this.closeAdd()
          await this.getLists()

          return
        }
      },
      handleAvatarSuccess(e) {
        this.userForm.logo_url = getCompletionUrl(e.data.file)
      },
      async deleteItem(row) {
        const res = await deleteUser({
          id: row.id,
        })
        if (isSuccess(res.code)) {
          if (this.userLists.length == 1 && this.currentPage != 1) {
            this.currentPage -= 1
          }
          await this.getLists()
          this.$message.success('删除成功')
          return
        }
      },
      resetPassword(item) {
        this.currentItem = item
        this.resetVisible = true
      },
      async changePassword() {
        if (this.currentItem.password.length < 6) {
          this.$message.error('长度在至少为6位数')
          return
        }
        const res = await resetPassword({
          id: this.currentItem.id,
          password: this.currentItem.password,
        })
        if (isSuccess(res.code)) {
          this.$message.success('重置成功')
          await this.getLists()
          this.resetVisible = false
          return
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .delete {
    margin-left: 10px;
  }
</style>
